import { Tooltip } from '@mantine/core'
import React from 'react'
import { textDecoration } from 'src/variable/constant'

function CustomTooltip({ label, maxWidth = 400, children = undefined, ...props }) {
	return (
		<Tooltip
			label={label}
			withinPortal={false}
			zIndex={9999}
			multiline
			sx={{
				maxWidth,
				// backgroundColor: 'red',
				whiteSpace: 'normal',
				padding: 10,
				wordBreak: 'break-word',
			}}
			{...props}
		>
			<div
				style={{
					maxWidth: maxWidth,
					...textDecoration,
				}}
			>
				{children ?? label}
			</div>
		</Tooltip>
	)
}

export default React.memo(CustomTooltip)
